/*
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */

function markNotificationReadUnread(id) {
    var data = "&notificationId="+id;
    $.ajax({
        type: "POST",
        url: "markNotificationStatus.htm",
        data: data,
        dataType: 'json',
        success: function() {
        },
        error: function() {
        }
    });
}

function getRolesList() {
    var data = "&accountNames="+$('#accountNames').val();
    $.ajax({
        type: "POST",
        url: "getAccountRoles.htm",
        data: data,
        dataType: 'json',
        success: function(response) {
           var rolesMap = response.roles;
           var options = '<option value="all" selected>All</option>';
            $.each(rolesMap, function (key, value) {
              options += '<option value="' + key + '">' + value.label + '</option>';
           });
           $("select#roles").html(options);
        },
        error: function() {
        }
    });
}
